import { useNavigate } from 'react-router-dom'
import { RouletteCreate } from '@/components/roulette/RouletteCreate'
import type { RouletteWithStats } from '@/types/roulette'

export function RouletteCreatePage() {
  const navigate = useNavigate()

  const handleCreateSuccess = (roulette: RouletteWithStats) => {
    navigate(`/dashboard/roulette/${roulette.id}`)
  }

  const handleCreateCancel = () => {
    navigate('/dashboard/roulette')
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <RouletteCreate onCancel={handleCreateCancel} onSuccess={handleCreateSuccess} />
      </div>
    </div>
  )
}
